var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5756 3.84372C15.237 3.58041 14.763 3.58041 14.4244 3.84372L5.04943 11.1354C4.82107 11.313 4.6875 11.5861 4.6875 11.8754V23.3337C4.6875 24.1349 5.00577 24.9033 5.57228 25.4698C6.1388 26.0363 6.90716 26.3546 7.70833 26.3546H22.2917C23.0928 26.3546 23.8612 26.0363 24.4277 25.4698C24.9942 24.9033 25.3125 24.1349 25.3125 23.3337V11.8754C25.3125 11.5861 25.1789 11.313 24.9506 11.1354L15.5756 3.84372ZM6.5625 23.3337V12.3339L15 5.77142L23.4375 12.3339V23.3337C23.4375 23.6376 23.3168 23.9291 23.1019 24.144C22.887 24.3589 22.5956 24.4796 22.2917 24.4796H19.0625V15C19.0625 14.4822 18.6428 14.0625 18.125 14.0625H11.875C11.3572 14.0625 10.9375 14.4822 10.9375 15V24.4796H7.70833C7.40444 24.4796 7.11299 24.3589 6.89811 24.144C6.68322 23.9291 6.5625 23.6376 6.5625 23.3337ZM12.8125 24.4796H17.1875V15.9375H12.8125V24.4796Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9241567efca5b92c3393c70f75447ba1.svg";
export { ForwardRef as ReactComponent };